(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouchDevice = !window.matchMedia('(pointer: fine)').matches;

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    function observeReveals() {
      var sel = '[data-reveal]:not(.is-revealed), .product-card:not(.is-revealed), .product-list-item:not(.is-revealed), .salty-product:not(.is-revealed)';
      document.querySelectorAll(sel).forEach(function (el) {
        if (reduceMotion) { el.classList.add('is-revealed'); }
        else { revealObserver.observe(el); }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeReveals);
    else observeReveals();
    new MutationObserver(observeReveals).observe(document.body, { childList: true, subtree: true });
  }

  if (reduceMotion) return;

  // Split text
  function splitText(el) {
    if (el.dataset.splitDone === 'true') return;
    var text = el.textContent.trim();
    var html = '', idx = 0;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (ch === ' ') html += '<span class="salty-split-space">&nbsp;</span>';
      else { html += '<span class="salty-split-char" style="animation-delay:' + (idx * 30) + 'ms;">' + ch + '</span>'; idx++; }
    }
    el.innerHTML = html;
    el.dataset.splitDone = 'true';
  }
  document.querySelectorAll('[data-split-text]').forEach(splitText);

  // Parallax hero
  var heroImages = document.querySelectorAll('.salty-hero__media img');
  if (heroImages.length) {
    var ticking = false;
    function updateParallax() {
      var scrollY = window.scrollY || window.pageYOffset;
      heroImages.forEach(function (img) {
        var rect = img.closest('.salty-hero').getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        img.style.transform = 'translateY(' + (scrollY * 0.25) + 'px) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(updateParallax); ticking = true; }
    }, { passive: true });
  }

  // Scroll progress bar
  var progressBar = document.createElement('div');
  progressBar.className = 'salty-scroll-progress';
  document.body.appendChild(progressBar);
  function updateProgress() {
    var scrolled = window.scrollY || window.pageYOffset;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    progressBar.style.width = (max > 0 ? (scrolled / max) * 100 : 0) + '%';
  }
  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();
})();
